import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  HeaderComponent: {
    position: "sticky",
    top: 0,
    width: "100%",
    height: "80px",
    zIndex: 100,
  },
}));
